// extracted by mini-css-extract-plugin
export default {"spinner__wrapper":"LoadingSpinner_spinner__wrapper__Tw98q","spinner":"LoadingSpinner_spinner__40kOg"};